<template>
  <div class="topabout__list__right__item">
    <router-link :to="itemAboutChild.link"><span v-html="itemAboutChild.about_title"></span></router-link>
    <!-- <div class="bg-item">
      <router-link to="/coming-soon">
        <span>Coming Soon 準備中</span>
      </router-link>
    </div> -->
  </div>
</template>

<script>

export default {
  name: "ItemEvent",
  props: {
    itemAboutChild: {
      type: Object,
    },
    index: {
      type: Number
    }
  },
  components: {
  },

  computed: {},
};
</script>